import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { debounceTime, distinctUntilChanged, filter, tap, throttleTime } from 'rxjs/operators';

@Component({
  selector: 'gen-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class SearchFieldComponent implements OnInit {

  @Input()
  set value(val: string) {
    val = val || '';
    this.previousValue = val ? this.previousValue : '';
    this.searchVal = val;
    this.valueChange.emit(val);
    this.change$.next(val);
  }

  get value() {
    return this.searchVal;
  }

  @Input()
  set loading(status: boolean) {
    this.load = status;
    this.loadChange.emit(status);
  }

  get loading() {
    return this.load;
  }

  constructor() {
    this.change$.asObservable()
      .pipe(
        distinctUntilChanged(),
        debounceTime(300),
        tap(() => {
/*          console.log(this.searchVal);*/
          return this.autoSearch ? this.search() : null;
        }),
        filter(() => !this.searchVal)
      )
      .subscribe((val) => {
        this.clear();
      });
  }
  public static SPACE_CLEAN_REGEX: string = '(.*?)(\\s+$)';
  public searchVal: string;
  public load: boolean = false;
  public previousValue: string;
  private change$: Subject<string> = new Subject();
  @Output() loadChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() clearEmit: EventEmitter<null> = new EventEmitter<null>();
  @Output() searchEmit: EventEmitter<string> = new EventEmitter<string>();

  @Input() placeholder: string = 'Search';
  @Input() removeExtraSpaces: boolean = false;
  @Input() autoSearch: boolean = true;
  @Input() selfHandler: boolean = true;

  ngOnInit() {   
  }

  public search() {
    if (this.previousValue === this.searchVal) { return; }
    if (this.selfHandler) {
      this.loading = true;
    }
    this.previousValue = this.searchVal;
    let val = this.searchVal;
    if (this.removeExtraSpaces) {
      const clearSpaceRegex = new RegExp(SearchFieldComponent.SPACE_CLEAN_REGEX);
      const regGroups = clearSpaceRegex.exec(val);
      val = regGroups && regGroups.length > 1 ? regGroups[1] : val;
    }
    this.searchEmit.emit(val);
  }

  public clear() {
    this.value = '';
    this.loading = false;
    this.clearEmit.emit();
  }

}
